import { gql } from '@apollo/client'
import { FIELD_FRAGMENT } from 'graphql/field/queries'

// fragments
export const PLAN_KPI_DETAILS_FRAGMENT = gql`
  fragment PLAN_KPI_DETAILS on PlanKPI {
    id
    archived
    description
    inputMethod
    isBookmark
    fields {
      ...FIELD
    }
    fieldValueMap {
      fieldName
      fieldValue
      fieldType
    }
    memberUsers {
      id
      firstName
      lastName
    }
    memberPositions {
      id
      description
    }
    ownedById
    ownedByUser {
      id
      firstName
      lastName
    }
    ownedByPosition {
      id
      description
      user {
        id
        firstName
        language
      }
    }
    planItems {
      data {
        id
        path
        planId
        plan {
          id
          companyId
          ownedById
          locked
          memberPositions {
            id
          }
          memberUsers {
            id
          }
          private
          parentPlanId
          name
          scheduleDefaults {
            entityType
            levelId
            repeating
            repeatEveryValue
            repeatEveryType
            periodEndsOn
            startPeriod
            endPeriod
            endsOn
            endsOnDate
            reviewDate {
              date
              end
              value
              period
            }
          }
          planType {
            id
            description
            levels {
              id
              color
              position
              description
            }
            objectiveOwnerObjectSecurityId
            objectiveMemberObjectSecurityId
            actionOwnerObjectSecurityId
            actionMemberObjectSecurityId
            kpiOwnerObjectSecurityId
            kpiMemberObjectSecurityId
            planOwnerObjectSecurityId
            planMemberObjectSecurityId
          }
        }
        referenced
      }
    }
    recurrence
    resultBaseline
    resultBaselineScale
    resultTarget
    resultType
    resultTypeScale {
      id
      active
      position
      label
      value
    }
  }
  ${FIELD_FRAGMENT}
`

export const PLAN_KPI_LINKED_ITEMS_FRAGMENT = gql`
  fragment PLAN_KPI_LINKED_ITEMS on PlanKPI {
    destinationLinkingItems {
      id
      parentId
      weighting
      createdAt
      description
      sourcePlanKPIId
      destinationPlanKPIId
      sourcePlanActionId
      destinationPlanActionId
      sourcePlanObjectiveId
      destinationPlanObjectiveId
      sourcePlanKPI {
        id
        description
        destinationLinkingItems {
          id
        }
        sourceLinkingItems {
          id
        }
        planItems {
          data {
            id
            path
            plan {
              id
              name
            }
            referenced
          }
        }
      }
      destinationPlanKPI {
        id
        description
        destinationLinkingItems {
          id
        }
        sourceLinkingItems {
          id
        }
        planItems {
          data {
            id
            path
            plan {
              id
              name
            }
            referenced
          }
        }
      }
      sourcePlanAction {
        id
        description
        destinationLinkingItems {
          id
        }
        sourceLinkingItems {
          id
        }
        planItems {
          data {
            id
            path
            plan {
              id
              name
            }
            referenced
          }
        }
      }
      destinationPlanAction {
        id
        description
        destinationLinkingItems {
          id
        }
        sourceLinkingItems {
          id
        }
        planItems {
          data {
            id
            path
            plan {
              id
              name
            }
            referenced
          }
        }
      }
      sourcePlanObjective {
        id
        description
        destinationLinkingItems {
          id
        }
        sourceLinkingItems {
          id
        }
        planItems {
          data {
            id
            path
            plan {
              id
              name
            }
            referenced
          }
        }
      }
      destinationPlanObjective {
        id
        description
        destinationLinkingItems {
          id
        }
        sourceLinkingItems {
          id
        }
        planItems {
          data {
            id
            path
            plan {
              id
              name
            }
            referenced
          }
        }
      }
    }
    sourceLinkingItems {
      id
      parentId
      weighting
      createdAt
      description
      sourcePlanKPIId
      destinationPlanKPIId
      sourcePlanActionId
      destinationPlanActionId
      sourcePlanObjectiveId
      destinationPlanObjectiveId
      sourcePlanKPI {
        id
        description
        destinationLinkingItems {
          id
        }
        sourceLinkingItems {
          id
        }
        planItems {
          data {
            id
            path
            plan {
              id
              name
            }
            referenced
          }
        }
      }
      destinationPlanKPI {
        id
        description
        destinationLinkingItems {
          id
        }
        sourceLinkingItems {
          id
        }
        planItems {
          data {
            id
            path
            plan {
              id
              name
            }
            referenced
          }
        }
      }
      sourcePlanAction {
        id
        description
        destinationLinkingItems {
          id
        }
        sourceLinkingItems {
          id
        }
        planItems {
          data {
            id
            path
            plan {
              id
              name
            }
            referenced
          }
        }
      }
      destinationPlanAction {
        id
        description
        destinationLinkingItems {
          id
        }
        sourceLinkingItems {
          id
        }
        planItems {
          data {
            id
            path
            plan {
              id
              name
            }
            referenced
          }
        }
      }
      sourcePlanObjective {
        id
        description
        destinationLinkingItems {
          id
        }
        sourceLinkingItems {
          id
        }
        planItems {
          data {
            id
            path
            plan {
              id
              name
            }
            referenced
          }
        }
      }
      destinationPlanObjective {
        id
        description
        destinationLinkingItems {
          id
        }
        sourceLinkingItems {
          id
        }
        planItems {
          data {
            id
            path
            plan {
              id
              name
            }
            referenced
          }
        }
      }
    }
  }
`

export const PLAN_KPI_REVIEWS_FRAGMENT = gql`
  fragment PLAN_KPI_REVIEWS on PlanKPI {
    scheduledReviews {
      id
      planId
      companyId
      repeating
      repeatEveryValue
      repeatEveryType
      periodEndsOn
      startPeriod
      endPeriod
      scheduledReviewers {
        id
        userId
        positionId
        scheduledReviewId
        reviewDate {
          end
          value
          date
          period
        }
        user {
          id
          firstName
          lastName
          avatarUrl
        }
        position {
          id
          description
        }
      }
      endsOn
      endsOnDate
    }
    reviews {
      id
      planId
      createdAt
      updatedAt
      startPeriod
      endPeriodAt
      dueAt
      scheduledReviewId
      scheduledReview {
        id
        planId
        companyId
        repeating
        repeatEveryValue
        repeatEveryType
        periodEndsOn
        startPeriod
        endPeriod
        scheduledReviewers {
          id
          userId
          positionId
          scheduledReviewId
          reviewDate {
            end
            value
            date
            period
          }
          user {
            id
            firstName
            lastName
            avatarUrl
          }
          position {
            id
            description
          }
        }
        endsOn
        endsOnDate
      }
      status
      values {
        goals
        doWell
        doBetter
      }
      fieldValueMap {
        fieldId
        fieldValueId
        fieldValue
        fieldLabel
      }
      updatedBy {
        id
        firstName
        lastName
      }
    }
  }
`

export const PLAN_KPI_PERMISSIONS_FRAGMENT = gql`
  fragment PLAN_KPI_PERMISSIONS on PlanKPI {
    currentPermissions {
      kpiArchiveKPI
      kpiAddAction
      kpiAddKPI
      kpiAddKPIResult
      kpiAddObjective
      kpiCreateScheduledReview
      kpiDeleteKPI
      kpiDeleteKPIResult
      kpiDeleteScheduledReview
      kpiLinkObjects
      kpiModifyKPI
      kpiModifyKPIResult
      kpiModifyScheduledReview
      kpiModifyUserKPISecurity
      kpiViewCompletedReview
      kpiViewInProgressReview
      planLinkObjects
    }
  }
`

// queries
export const PLAN_KPI_DETAILS_QUERY = gql`
  query PLAN_KPI_DETAILS_QUERY($filter: PlanKPIFilterInput!) {
    planKPIs(filter: $filter) {
      pagination {
        pageSkip
        pageTake
        totalCount
      }
      data {
        ...PLAN_KPI_DETAILS
        ...PLAN_KPI_LINKED_ITEMS
        ...PLAN_KPI_REVIEWS
        ...PLAN_KPI_PERMISSIONS
      }
    }
  }
  ${PLAN_KPI_DETAILS_FRAGMENT}
  ${PLAN_KPI_LINKED_ITEMS_FRAGMENT}
  ${PLAN_KPI_REVIEWS_FRAGMENT}
  ${PLAN_KPI_PERMISSIONS_FRAGMENT}
`

export const PLAN_KPI_ACTIVITIES_LIST_QUERY = gql`
  query PLAN_KPI_ACTIVITIES_LIST_QUERY($filter: LogFilterInput!) {
    logs(filter: $filter) {
      data {
        id
        entityType
        entityId
        actionType
        createdAt
        metadata {
          fileName
          fileUrl
          fileContentType
          comment
        }
        user {
          id
          firstName
          lastName
          avatarUrl
        }
        kpi {
          id
          description
        }
      }
    }
  }
`

export const PLAN_KPI_LIST_QUERY = gql`
  query PLAN_KPI_LIST_QUERY($filter: PlanKPIFilterInput!, $order: OrderInput, $pagination: PaginationInput) {
    planKPIs(filter: $filter, order: $order, pagination: $pagination) {
      pagination {
        pageSkip
        pageTake
        totalCount
      }
      data {
        id
        description
        planItems(filter: { referenced: false }) {
          data {
            id
            plan {
              id
              name
              companyId
            }
          }
        }
        ownedByUser {
          id
          firstName
          lastName
        }
        ownedByPosition {
          id
          description
          user {
            id
            firstName
            language
          }
        }
        recurrence
        resultTarget
        resultType
        resultTypeScale {
          id
          label
          value
        }
        fieldValueMap {
          fieldName
          fieldValue
        }
        ...PLAN_KPI_REVIEWS
      }
    }
  }
  ${PLAN_KPI_REVIEWS_FRAGMENT}
`
